import { Phone } from "@element-plus/icons"

const Nav = {
  list:'数组',
  product:"产品中心",
  about_shinetech:'关于盛泰',
  news:'新闻资讯',
  collaborate:'合作与发展',
  join_us:'加入我们',
  contact_us:'联系我们'
}

const AiChat = {
  buttonIcon:"bot_button_zh.png",
  buttonText:"AI客服",
  title:"盛泰智能客服",
  content:"您好呀，我是基于 DeepSeek 的AI 客服，很期待能帮您解答与盛泰产品相关的疑问哦~",
  loading:"请稍后...",
  placeholder:"请输入您要咨询的问题",
  send:"发送",

  customerForm:{
    productLabel:"沟通意向",
    productPlaceholder:"请选择沟通意向",
    phoneLabel:"联系方式",
    phonePlaceholder:"请输入您的联系方式",
    nameLabel:"您的称呼",
    namePlaceholder:"请输入您的称呼",
  },
}

const Contactus = {
  formTitle:"合作咨询",
  Form:{
    name:"姓名",
    namePlaceholder:"请输入您的姓名",
    nameMaxLength:"长度不能超过50个字符",
    phone:"电话",
    phonePlaceholder:"请输入您的电话",
    phoneMaxLength:"电话长度不能超过20个字符",
    email:"邮箱",
    emailPlaceholder:"请输入您的邮箱",
    emailMaxLength:"长度不能超过100个字符",
    company:"公司",
    companyPlaceholder:"请输入您的公司",
    companyMaxLength:"长度不能超过100个字符",
    content:"留言",
    contentPlaceholder:"请输入您的留言",
    contentMaxLength:"长度不能超过500个字符",
    submit:"提交",
    phoneError:"电话号码格式不正确",
    submitFrequent:"提交过于频繁，请1分钟之后再试",
    submitConfirmation:"确认填写无误，即将提交表单？",
    submitCancel:"取消",
    submitTitle:"提示",
  }
}
  // 按功能模块导出
  export default {
    Nav,
    AiChat,
    Contactus,
  }